<template>
  <div
    :class="['search-box-wrapper', { transition }]"
    :style="`width: ${width}`"
  >
    <div v-if="gradation" class="gradation" @click="onClickGradation"></div>
    <label for="search" class="search-icon">
      <w-search-icon color="#A5A5A5" />
    </label>
    <input
      id="search"
      ref="searchInput"
      type="text"
      class="search-input-box"
      name="search"
      :value="value"
      :placeholder="placeholder"
      @input="onInput"
      @keydown="onKeydown"
      @focus="onFocus"
    />
    <button
      v-if="value?.length > 0"
      :class="['search-delete-button']"
      @click.prevent="onClickDelete"
    >
      <w-delete-icon color="#A5A5A5" />
      <span class="a11y-hidden">검색어 삭제</span>
    </button>
  </div>
</template>

<script setup>
  import { onMounted, ref, nextTick } from 'vue'
  import WSearchIcon from '@/components/ui/Search/icon/WSearchIcon.vue'
  import WDeleteIcon from '@/components/ui/Search/icon/WDeleteIcon.vue'

  const emit = defineEmits([
    'input',
    'focus',
    'keydown-enter',
    'delete',
    'click-gradation',
  ])
  const props = defineProps({
    value: {
      type: String,
      default: '',
    },
    transition: {
      type: Boolean,
      default: false,
    },
    gradation: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '제목, 장르, 배우로 찾아보세요',
    },
    maxLength: {
      type: Number,
    },
  })
  const searchInput = ref(null)
  const width = ref('0')

  onMounted(() => {
    nextTick(() => {
      width.value = '360px'
      searchInput.value.focus()
    })
  })

  const onFocus = () => {
    emit('focus')
  }

  const onInput = (event) => {
    emit('input', event)
    if (props.maxLength && event.target.value.length > props.maxLength) {
      event.target.value = event.target.value.slice(0, props.maxLength)
    }
  }

  const onKeydown = (event) => {
    if (event.isComposing || event.keyCode === 229) return
    if (event.key === 'Enter') {
      emit('keydown-enter', event)
    }
  }

  const onClickDelete = () => {
    searchInput.value.focus()
    emit('delete')
  }

  const onClickGradation = () => {
    emit('click-gradation')
  }
</script>

<style lang="scss" scoped>
  .search-box-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    height: 40px;
    background: rgba(0, 0, 0, 1);
    border: 1px solid rgba(47, 47, 47, 1);
    border-radius: 4px;
    padding: 8px 12px;
    box-sizing: border-box;
    .search-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 8px;
      cursor: default;
    }

    .search-input-box {
      flex: 1;
      width: 100%;
      height: 100%;
      font-size: 16px;
      line-height: 24px;
      border: none;
      padding: 0;
      color: #fff;
      margin-right: 12px;
      border-radius: 0;
      &::placeholder {
        color: #a5a5a5;
      }
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px rgba(0, 0, 0, 1) inset;
        box-shadow: 0 0 0 1000px rgba(0, 0, 0, 1) inset;
        -webkit-text-fill-color: #fff;
      }
    }
    .search-input-box:focus + .search-delete-button {
      opacity: 1;
    }
    .search-delete-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      opacity: 0;
      transition: opacity 0.2s ease-out;
      &:focus,
      &:active {
        opacity: 1;
      }
    }
    &.transition {
      transition:
        width 0.2s ease-out,
        opacity 0.2s ease-out;
    }
    .gradation {
      display: inline-block;
      position: absolute;
      left: -81px;
      width: 80px;
      height: 40px;
      background: linear-gradient(90deg, rgba(27, 27, 27, 0) 0%, #1b1b1b 100%);
      content: '';
    }
  }
</style>
